import { ChevronDown, ChevronUp } from "lucide-react";

const ProgramSpecificOutcomes = ({
  outcomes,
  isExpanded,
  onToggle,
  darkMode,
}) => {
  return (
    <div className="mb-4">
      <div className="flex items-center cursor-pointer mb-2" onClick={onToggle}>
        <h4
          className={`text-base font-semibold ${
            darkMode ? "text-white" : "text-gray-700"
          }`}
        >
          Program Specific Outcomes
        </h4>
        {isExpanded ? (
          <ChevronUp
            size={16}
            className={`ml-2 ${darkMode ? "text-gray-400" : "text-gray-500"}`}
          />
        ) : (
          <ChevronDown
            size={16}
            className={`ml-2 ${darkMode ? "text-gray-400" : "text-gray-500"}`}
          />
        )}
      </div>

      {isExpanded && (
        <div className="space-y-2">
          {outcomes.length > 0 ? (
            outcomes.map((pso) => (
              <div
                key={pso.pso_number}
                className={`p-2 rounded ${
                  darkMode ? "bg-[#161B22]" : "bg-gray-50"
                }`}
              >
                <p
                  className={`text-sm font-medium ${
                    darkMode ? "text-white" : "text-gray-800"
                  }`}
                >
                  <span className="font-semibold">{pso.pso_number}:</span>{" "}
                  {pso.pso_description}
                </p>
              </div>
            ))
          ) : (
            <p
              className={`text-xs ${
                darkMode ? "text-gray-400" : "text-gray-500"
              }`}
            >
              No program specific outcomes defined yet.
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default ProgramSpecificOutcomes;
